module.exports = __webpack_public_path__ + "static/img/14000065.7170a0a7.png";